import { render, staticRenderFns } from "./DetailImport.vue?vue&type=template&id=06dc7350&"
import script from "./DetailImport.vue?vue&type=script&lang=js&"
export * from "./DetailImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports